import { makeStyles } from '@mui/styles';

export const useLockerUtilisationChartCardStyles = makeStyles(() => ({
  card: {
    padding: '24px',
    borderRadius: '10px'
  },
  divider: {
    borderBottom: '1px solid #EBEDF2',
    width: 'calc(100% + 32px)',
    height: '1px',
    marginLeft: '-16px',
    marginRight: '-16px',
    marginBottom: '24px'
  }
}));
